import React from "react";
import styled from "styled-components";
import FabricIcon from "@components/Icons/FabricIcon";

const EventWrapper = styled.div`
	position: absolute;
	display: flex;
	justify-content: center;
	top: ${({ top }) => top};
	left: ${({ left }) => left};
	flex-direction: column;
	width: 22px;

	h4.miniHeader {
		font-size: 13.5px;
		margin-bottom: 0.3px;
		display: block;
		transform-origin: left;
		transform: translateX(10px) rotateZ(-55deg);
		width: 200px;
	}
`;

const IconContainer = styled.div`
	width: 24px;
	height: 24px;
	padding: 0;
	margin: 3px;
	border-radius: 12px;
	background-color: ${({ color }) => color};
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	cursor: pointer;
`;

const EventIconsWrapper = styled.button`
	padding: 0;
	background: none;
	background-color: #1c2229;
	width: 30px;
	min-height: 30px;
	border-radius: 15px;
	border: none;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const EventInfoWrapper = styled.div`
	.flip {
		transform: translateX(-178px);
	}
	z-index: 9000;
`;

const EventInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 320px;
	max-height: 210px;
	overflow-y: auto;
	transform: translateX(${props => props.leftPlacement});
	background-color: #1c2229;
	color: white;
	padding: 8px;
	border-radius: 2px;

	h5 {
		font-size: 14px;
		margin-bottom: 8px;
		padding-left: 3px;
	}

	p {
		font-size: 15px;
		line-height: 1.2em;
		margin-bottom: 5px;
	}

	a {
		color: #2990ff;
	}

	div:not(:last-child) {
		border-bottom: 1px solid #777;
		margin-bottom: 1em;
		padding-bottom: 0.7em;
	}
`;

const EventArrow = styled.div`
	width: 3px;
	transform: translateX(13px);
	height: ${props => props.height}px;
	background-color: #1c2229;
`;

const EventLink = styled.a`
	border-radius: 4px;
	padding: 4px;
	font-size: 12px;
	color: #fefefe !important;

	:hover {
		color: #fff;
	}
`;

const EventIcon = ({ iconName, iconColor }) => (
	<IconContainer color={iconColor}>
		<FabricIcon iconName={iconName} style={{ fontSize: "16px" }} />
	</IconContainer>
);

function getEventMiniHeader(eventGroup) {
	const firstDateSplit = eventGroup[0].date.toDateString().split(" ");
	const lastDateSplit = eventGroup[eventGroup.length - 1].date
		.toDateString()
		.split(" ");

	const miniHeader =
		`${firstDateSplit[1]} ${firstDateSplit[3]}` +
		(lastDateSplit[1] === firstDateSplit[1]
			? ""
			: ` - ${lastDateSplit[1]} ${lastDateSplit[3]}`);

	return miniHeader;
}

const days = [
	"Sunday",
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday",
];

const months = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
];

const getDaySuffix = day => {
	const suffix = ["th", "st", "nd", "rd"];
	let dayNum = day;
	if (dayNum > 19) {
		dayNum = parseInt(dayNum.toString()[1]);
	}
	return dayNum > suffix.length - 1 ? "th" : suffix[dayNum];
};

const getLongDateFormat = date =>
	`${days[date.getDay()]}, ${months[date.getMonth()]} ${date.getDate() +
		getDaySuffix(date.getDate())}, ${date.getFullYear()}`;

const EventInfo = ({ isVisible, iconMap, eventGroup, largestGroupSize }) => {
	const getInfoLeftPlacement = group =>
		-1 * Math.round(group[0].placement * 100) +
		10 * group[0].placement +
		"%";

	return (
		<EventInfoWrapper
			style={{
				opacity: isVisible ? 1 : 0,
				pointerEvents: isVisible ? "auto" : "none",
			}}
		>
			<EventArrow
				height={largestGroupSize * 30 - eventGroup.length * 30 + 5}
			/>
			<EventInfoContainer
				leftPlacement={getInfoLeftPlacement(eventGroup)}
			>
				{eventGroup.map(event => (
					<div key={`event-description-${event.id}`}>
						<h5
							id={`event-date-header-${event.id}`}
							style={{
								borderLeft:
									"3px solid " + iconMap[event.icon].color,
							}}
						>
							{getLongDateFormat(event.date)}
						</h5>
						{event.description}
						{event.url ? (
							<EventLink
								aria-label={`More information about ${event.plainTextDescription}`}
								href={event.url}
								style={{
									backgroundColor: iconMap[event.icon].color,
								}}
							>
								More Info
							</EventLink>
						) : null}
					</div>
				))}
			</EventInfoContainer>
		</EventInfoWrapper>
	);
};

const RenderEvent = ({
	eventGroup,
	flipEventInfo,
	isVisible,
	handleUserSelect,
	iconMap,
	top,
	largestGroupSize,
}) => {
	const miniHeader = getEventMiniHeader(eventGroup);

	const groupHeaderId = `timeline-group-header-${miniHeader.replace(
		/\s/g,
		""
	)}`;

	return (
		<EventWrapper
			top={top}
			left={Math.round(eventGroup[0].placement * 100) + "%"}
		>
			<h4 id={groupHeaderId} className="miniHeader">
				{miniHeader}
			</h4>
			<EventIconsWrapper
				onClick={handleUserSelect}
				onFocusCapture={handleUserSelect}
				aria-labelledby={groupHeaderId}
			>
				{eventGroup.map(event => (
					<EventIcon
						iconName={iconMap[event.icon].icon}
						iconColor={iconMap[event.icon].color}
						key={`event-${event.id}`}
					/>
				))}
			</EventIconsWrapper>
			<EventInfo
				isVisible={isVisible}
				flipEventInfo={flipEventInfo}
				iconMap={iconMap}
				eventGroup={eventGroup}
				largestGroupSize={largestGroupSize}
			/>
		</EventWrapper>
	);
};

export default RenderEvent;
